import { Typography } from '@euler/app/components/typography';
import { Center } from '@euler/components/Center';
import { StatusColors } from '@euler/components/Colors';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

export const ReadonlyDiscountButton = memo(
  ({
    price,
    discountPrice,
    discount,
    style,
  }: {
    price: number | undefined;
    discountPrice: number | undefined;
    discount?: number;
    style?: StyleProp<ViewStyle>;
  }) => {
    const { rpx } = useResponsiveContext();

    const originalPrice = discountPrice ?? price;

    if (!discount || originalPrice == null || originalPrice === 0) {
      return null;
    }

    const text = `${(((originalPrice - discount) / originalPrice) * 10)
      .toFixed(1)
      .replace(/\.0+$/, '')}折`;

    return (
      <Center
        style={style}
        css={`
          background-color: ${discount != null && discount > 0
            ? StatusColors.Info
            : '#999'};
          border-radius: 100px;
          min-width: ${rpx(16)}px;
          height: ${rpx(16)}px;
          padding: ${rpx(2)}px ${rpx(3)}px;
        `}
      >
        <Typography.Text color="#fff" size={rpx(9)} lineHeight={rpx(12)}>
          {text}
        </Typography.Text>
      </Center>
    );
  },
);
